'use client'

import { FC } from 'react'
import styled from 'styled-components'

import { EmbroideryThread, TypeStyle } from '@syconium/little-miss-figgy'
import { Button } from '@syconium/little-miss-figgy/dist/components/Button'

import { useCart } from '../../../../app/_providers/CartProvider.client'
import { useLoop } from '../../../../app/_providers/LoopProvider.client'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { useCartEmbroideryUpsell } from '../../../../containers/EmbroideryContainer/CartEmbroideryUpsellProvider'
import { CartItem } from '../../../../types/figs'

export const AddEmbroideryUpsellButton: FC<{
  cartItem: CartItem
}> = ({ cartItem }) => {
  const { isItemEligibleForUpsell, openEmbroideryUpsellModal } = useCartEmbroideryUpsell()
  const { isItemRemovalInProgress } = useCart()
  const { inLoopFlow } = useLoop()
  const {
    embroidery: {
      embroideryUpsell: { CartAddEmbroidery: addEmbroideryText },
    },
  } = useTranslation()

  if (inLoopFlow || !isItemEligibleForUpsell(cartItem)) return null

  return (
    <StyledButton
      allCaps={false}
      aria-label={addEmbroideryText}
      onClick={() => openEmbroideryUpsellModal(cartItem)}
      disabled={isItemRemovalInProgress(cartItem.key)}
    >
      <EmbroideryThread width='16px' height='16px' />
      <PillText>{addEmbroideryText}</PillText>
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: ${o => o.theme.spacing(1)};
  align-self: flex-start;
  min-height: 0;
  height: ${o => o.theme.spacing(6)};
  margin: ${o => o.theme.spacing(4, 0, 0, 0)};
  padding: ${o => o.theme.spacing(1, 2)};
  border: none;
  border-radius: 20px;
  background-color: ${o => o.theme.color.fill.subtle};
  color: ${o => o.theme.color.text.primary.on.subtle};

  &:hover {
    background-color: ${o => o.theme.color.fill.subtle};
    color: ${o => o.theme.color.text.primary.on.subtle};
  }

  &[disabled],
  &[aria-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

const PillText = styled.span`
  ${TypeStyle.css.bodyNano};
  font-weight: 700;
`
